
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-4b116c08&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./SeriesMaster.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./SeriesMaster.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-4b116c08!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./SeriesMaster.vue"),
  /* scopeId */
  "data-v-4b116c08",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/microfinance/master/SeriesMaster.vue
// module id = 752
// module chunks = 0